export enum PANEL_VIEW {
  FULL = 'full',
  MINIMUM = 'minimum',
}
